const DetectOS = () => {
  const userAgent = navigator.userAgent || window.opera;

  // Detecting Android
  if (/android/i.test(userAgent)) {
    return 'android';
  }
  // Detecting iOS
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }
  // Fallback for other platforms
  return 'desktop';
};

export default DetectOS;
